import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent implements OnInit {

  username: string = '';
  sessionName: string = '';
  baseUrl = 'https://chatbot.meshilogic.com/TCS';
  messages: any[] = [];
  isOpen = false;
  question = '';
  sessionStarted = false;
  showHelpBubble: boolean = false;
  loading: boolean = false;


  @ViewChild('scrollMe') private chatContainer!: ElementRef;


  constructor(
    private http: HttpClient,
    private router: Router,
    private auth: AuthService,
  ) { }

  ngOnInit(): void {
    const user = this.auth.currentUserValue;
    if (user && user.UserID) {
      this.username = user.UserID;
    }

    if (!this.isOpen) {
      setTimeout(() => {
        this.showHelpBubble = true;
      }, 1000);
    }

  }



 toggleChat(): void {
  this.isOpen = !this.isOpen;

  setTimeout(() => {
    this.scrollToBottom();
  }, 200);

  if (this.isOpen) {
    this.showHelpBubble = false;

    const user = this.auth.currentUserValue;
    if (user && user.UserID) {
      this.username = user.UserID;

      // Always generate a new session name
      this.sessionName = 'session_' + Date.now();
      this.sessionStarted = false; // reset to ensure startSession() runs
      this.startSession();
      

    } else {
      this.messages.push({ sender: 'bot', text: '❌ Cannot start session. User not found.' });
    }

  } else {
    this.messages = [];
    this.sessionStarted = false;
    // Do NOT call endSession() here
    setTimeout(() => {
      this.showHelpBubble = true;
    }, 1000);
  }
}



  closeChat() {
    this.isOpen = false;
    this.endSession();
  }



  startSession() {
    this.http.post(this.baseUrl + '/start_session', {
      username: this.username,
      session_name: this.sessionName
    }).subscribe({
      next: () => {
        this.sessionStarted = true;
        
      },
      error: () => {
        this.messages.push({ sender: 'bot', text: '❌ Failed to start chat session.' });
      }
    });
  }



  sendMessage(): void {
    const question = this.question.trim();
    if (!question || !this.sessionStarted) return;

    this.messages.push({ sender: 'user', text: question });
    this.scrollToBottom();
    this.question = '';
    this.loading = true;

    this.http.post(this.baseUrl + '/ask', {
      username: this.username,
      session_name: this.sessionName,
      question: question
    }).subscribe({
      next: (response: any) => {
        this.loading = false;
        this.messages.push({ sender: 'bot', text: response.response || 'No response.' });
        this.scrollToBottom();
      },
      error: () => {
        this.loading = false;
        this.messages.push({ sender: 'bot', text: '❌ Error talking to the bot.' });
        this.scrollToBottom();
      }
    });
  }


  scrollToBottom(): void {
    try {
      setTimeout(() => {
        this.chatContainer.nativeElement.scroll({
          top: this.chatContainer.nativeElement.scrollHeight,
          behavior: 'smooth'
        });
      }, 100); // slight delay to wait for DOM update
    } catch (err) {
      console.error('Scroll error:', err);
    }
  }



  endSession(): void {
    this.http.post(this.baseUrl + '/end_session', {
      username: this.username,
      session_name: this.sessionName
    }).subscribe();
  }



  shouldHide(): boolean {
    return !this.auth.isLoggedIn || this.router.url === '/login';
  }

}